import React from "react";
import { Button } from "antd";

const OnboardingStartScreen = props => {
  return (
    <div className="onboarding-start-screen">
      <img src="/images/illustration-robot-hand.svg" alt="onboarding start screen" />
      <h2>Welcome on board!</h2>
      <h2>Let's finish your ToolBox setup.</h2>
      <span className="description">Complete 4 simple steps, usually takes about 2 minutes</span>
      <Button className="start-onboarding-btn" type="primary" onClick={props.handleStartOnboarding}>
        Let's Start
      </Button>
    </div>
  );
};

export default OnboardingStartScreen;
